import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import apiClient from '../api/client';
import './ConfiguracoesTemas.css';

/**
 * Página para Admin escolher tema do site
 */

const ConfiguracoesTemas = () => {
  const { isAdmin } = useAuth();
  const navigate = useNavigate();
  const [temas, setTemas] = useState([]);
  const [temaAtivo, setTemaAtivo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [editandoFrases, setEditandoFrases] = useState(false);
  const [frasesForm, setFrasesForm] = useState({ frase_ranking: '', frase_nocautes: '' });

  const nomesTemas = {
    tolkien: 'Tolkien',
    starwars: 'Star Wars',
    nintendo: 'Nintendo',
    'cavaleiros-zodiaco': 'Cavaleiros do Zodíaco',
    anime1: 'Anime 1 (One Piece, Naruto, Dragon Ball)',
    dc: 'DC',
    marvel: 'Marvel',
    'jogos-retro': 'Jogos Retrô',
    terror: 'Terror',
    'harry-potter': 'Harry Potter',
  };

  const iconesTemas = {
    tolkien: '🧙',
    starwars: '⭐',
    nintendo: '🎮',
    'cavaleiros-zodiaco': '⚔️',
    anime1: '🔥',
    dc: '🦇',
    marvel: '🦸',
    'jogos-retro': '🕹️',
    terror: '👻',
    'harry-potter': '⚡',
  };

  useEffect(() => {
    if (!isAdmin) {
      navigate('/dashboard');
      return;
    }
    carregarTemas();
  }, [isAdmin, navigate]);

  useEffect(() => {
    // Aplicar tema ativo quando carregar
    if (temaAtivo) {
      aplicarTema(temaAtivo.nome);
    }
  }, [temaAtivo]);

  const carregarTemas = async () => {
    try {
      setLoading(true);
      setError('');
      const [temasRes, temaAtivoRes] = await Promise.all([
        apiClient.get('/temas'),
        apiClient.get('/temas/ativo'),
      ]);
      setTemas(temasRes.data);
      setTemaAtivo(temaAtivoRes.data);
      if (temaAtivoRes.data) {
        setFrasesForm({
          frase_ranking: temaAtivoRes.data.frase_ranking || '🏆 Ranking de Pontos',
          frase_nocautes: temaAtivoRes.data.frase_nocautes || '🥊 Ranking de Nocautes',
        });
      }
    } catch (err) {
      console.error('Erro ao carregar temas:', err);
      setError(err.response?.data?.error || 'Erro ao carregar temas');
    } finally {
      setLoading(false);
    }
  };

  const aplicarTema = (nomeTema) => {
    // Remover classes de tema anteriores
    document.documentElement.className = '';
    document.documentElement.classList.add(`tema-${nomeTema}`);
  };

  const handleAtivarTema = async (nomeTema) => {
    try {
      setSalvando(true);
      setError('');
      setSuccess('');

      await apiClient.put(`/temas/${nomeTema}/ativar`);
      
      setSuccess(`Tema "${nomesTemas[nomeTema] || nomeTema}" ativado com sucesso!`);
      await carregarTemas();
      
      // Recarregar página após 1 segundo para aplicar o tema completamente
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (err) {
      console.error('Erro ao ativar tema:', err);
      setError(err.response?.data?.error || 'Erro ao ativar tema');
    } finally {
      setSalvando(false);
    }
  };

  const handleEditarFrases = () => {
    if (!temaAtivo) return;
    setEditandoFrases(true);
    setFrasesForm({
      frase_ranking: temaAtivo.frase_ranking || '🏆 Ranking de Pontos',
      frase_nocautes: temaAtivo.frase_nocautes || '🥊 Ranking de Nocautes',
    });
  };

  const handleSalvarFrases = async (e) => {
    e.preventDefault();
    if (!temaAtivo) return;

    try {
      setSalvando(true);
      setError('');
      setSuccess('');

      await apiClient.put(`/temas/${temaAtivo.nome}/frases`, {
        frase_ranking: frasesForm.frase_ranking.trim(),
        frase_nocautes: frasesForm.frase_nocautes.trim(),
      });

      setSuccess('Frases atualizadas com sucesso!');
      setEditandoFrases(false);
      await carregarTemas();
    } catch (err) {
      console.error('Erro ao salvar frases:', err);
      setError(err.response?.data?.error || 'Erro ao salvar frases');
    } finally {
      setSalvando(false);
    }
  };

  const handleCancelarEdicaoFrases = () => {
    setEditandoFrases(false);
    setFrasesForm({
      frase_ranking: temaAtivo?.frase_ranking || '🏆 Ranking de Pontos',
      frase_nocautes: temaAtivo?.frase_nocautes || '🥊 Ranking de Nocautes',
    });
  };

  if (loading) {
    return <div className="container">Carregando...</div>;
  }

  return (
    <div className="container configuracoes-temas-container">
      <div className="page-header">
        <h1>🎨 Configurações de Temas</h1>
        <button onClick={() => navigate('/admin/menu')} className="btn btn-secondary">
          ← Voltar
        </button>
      </div>

      {error && <div className="error">{error}</div>}
      {success && <div className="success">{success}</div>}

      <div className="info-box">
        <p>
          <strong>ℹ️ Informação:</strong> O tema selecionado será aplicado para todos os usuários do sistema.
          A alteração será visível imediatamente após a ativação.
        </p>
      </div>

      {temaAtivo && (
        <div className="tema-ativo-box">
          <h3>Tema Ativo Atualmente</h3>
          <div className="tema-card ativo">
            <div className="tema-icon">{iconesTemas[temaAtivo.nome] || '🎨'}</div>
            <div className="tema-info">
              <h4>{nomesTemas[temaAtivo.nome] || temaAtivo.nome}</h4>
              <span className="badge-ativo">Ativo</span>
            </div>
          </div>

          {/* Edição de Frases */}
          {!editandoFrases ? (
            <div className="frases-box">
              <h4>Frases Customizadas</h4>
              <div className="frases-display">
                <p><strong>Ranking:</strong> {temaAtivo.frase_ranking || '🏆 Ranking de Pontos'}</p>
                <p><strong>Nocautes:</strong> {temaAtivo.frase_nocautes || '🥊 Ranking de Nocautes'}</p>
              </div>
              <button onClick={handleEditarFrases} className="btn btn-secondary btn-sm" style={{ marginTop: '10px' }}>
                ✏️ Editar Frases
              </button>
            </div>
          ) : (
            <div className="frases-edit-box">
              <h4>Editar Frases do Tema</h4>
              <form onSubmit={handleSalvarFrases}>
                <div className="form-group">
                  <label>Frase do Ranking:</label>
                  <input
                    type="text"
                    value={frasesForm.frase_ranking}
                    onChange={(e) => setFrasesForm({ ...frasesForm, frase_ranking: e.target.value })}
                    className="form-input"
                    placeholder="🏆 Ranking de Pontos"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Frase dos Nocautes:</label>
                  <input
                    type="text"
                    value={frasesForm.frase_nocautes}
                    onChange={(e) => setFrasesForm({ ...frasesForm, frase_nocautes: e.target.value })}
                    className="form-input"
                    placeholder="🥊 Ranking de Nocautes"
                    required
                  />
                </div>
                <div className="form-actions">
                  <button type="submit" disabled={salvando} className="btn btn-primary btn-sm">
                    {salvando ? 'Salvando...' : 'Salvar'}
                  </button>
                  <button 
                    type="button" 
                    onClick={handleCancelarEdicaoFrases} 
                    disabled={salvando}
                    className="btn btn-secondary btn-sm"
                  >
                    Cancelar
                  </button>
                </div>
              </form>
            </div>
          )}
        </div>
      )}

      <div className="temas-grid">
        <h3>Escolher Novo Tema</h3>
        <div className="temas-list">
          {temas.map(tema => (
            <div
              key={tema.id}
              className={`tema-card ${tema.ativo ? 'ativo' : ''}`}
              onClick={() => !tema.ativo && handleAtivarTema(tema.nome)}
              style={{ cursor: tema.ativo ? 'default' : 'pointer', opacity: salvando ? 0.6 : 1 }}
            >
              <div className="tema-icon">{iconesTemas[tema.nome] || '🎨'}</div>
              <div className="tema-info">
                <h4>{nomesTemas[tema.nome] || tema.nome}</h4>
                {tema.ativo ? (
                  <span className="badge-ativo">Ativo</span>
                ) : (
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleAtivarTema(tema.nome);
                    }}
                    disabled={salvando}
                  >
                    Ativar
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ConfiguracoesTemas;
